/**
 * Carries the workbench's detach controls into dockview tabs (§5.8).
 *
 * Mirrors {@link SurfaceHostContext}: dockview only forwards serializable
 * `params`, so the detached-surface set and the shell's detach/attach/focus
 * callbacks cannot ride along with a panel — this Context is the bridge. Both
 * the tab header (its context menu) and the tab content (the migrate
 * placeholder) read it, so the two agree on whether an instance is detached.
 */
import { createContext } from 'react';

export interface TabDetachValue {
  /** Serialized handles of migrated surfaces; see `detachedSurfaceKey`. */
  readonly detachedSurfaces?: ReadonlySet<string>;
  readonly onDetachView?: (
    viewId: string,
    moduleId: string,
    instanceKey?: string,
  ) => void;
  readonly onAttachView?: (viewId: string, instanceKey?: string) => void;
  readonly onFocusDetached?: (viewId: string, instanceKey?: string) => void;
}

export const TabDetachContext = createContext<TabDetachValue>({});
